import React from "react";
import { Link } from "react-router-dom";
import "./css/Footer.css";
import RavookaLogo from "../assets/logo/Ravooka Logo - White.svg";
import { Heart } from "@phosphor-icons/react";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Left Section - Logo and Description */}
        <div className="footer-left">
          <img src={RavookaLogo} alt="Ravooka" className="footer-logo" />
          <p className="footer-description">
            A premium digital media advertising platform connecting advertisers and news publishers — Built on Research, Validated by Data.
          </p>
          <p className="footer-credit">
            <Heart size={16} weight="fill" color="#4444EF" />
            Designed & Built by <a href="https://itspriyanshu.com/" target="_blank" rel="noopener noreferrer" className="footer-credit-link">Priyanshu</a>
          </p>
        </div>

        {/* Right Section - Quick Links and Contact */}
        <div className="footer-right">
          {/* Quick Links Section */}
          <div className="footer-section">
            <h3 className="footer-heading">Quick Links</h3>
            <ul className="footer-links">
              <li>
                <Link to="/about-us" className="footer-link">
                  About us
                </Link>
              </li>
               <li>
                <Link to="/privacy" className="footer-link">
                  Privacy Policy
                </Link>
              </li>
              {/* <li>
                <Link to="/cancellations-and-refunds" className="footer-link">
                  Return & Refund Policy
                </Link>
              </li> */}
              <li>
                <Link to="/terms" className="footer-link">
                  Terms & Conditions
                </Link>
              </li> 
              <li>
                <Link to="/contact-us" className="footer-link">
                  Contact us
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Us Section */}
          <div className="footer-section">
            <h3 className="footer-heading">Contact</h3>
            <div className="contact-info">
              <p className="company-name">Ravooka</p>
              <p className="company-address">KH. NO. 446, 2nd FLOOR,</p>
              <p className="company-address">LUCKNOW, INDIA 260020</p>
              <p className="company-contact">
                Tel: <a href="tel:+918904330936">+91 8904330936</a>
              </p>
              <p className="company-email">
                Email: <a href="mailto:sup@ravooka.ai">sup@ravooka.ai</a>
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Divider */}
      <div className="footer-divider"></div>

      {/* Copyright Section */}
      <div className="copyright-section">
        <p className="copyright-text">
          © {new Date().getFullYear()}, All Rights Reserved By <Link to="/">Ravooka</Link>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
